export default {
  MAIN: 'main',
  TRACK: 'track',
  HIGHWAY: 'highway',
  MULTI_CHANNEL: 'multi-channel',
  CLAIM_TIMELINE: 'claim_timeline',
  LOCATION_ONLY: 'location_only',
  GARAGE_DESTINATION: 'garage_destination',
  RENTAL_CAR: 'rental_car',
};
